import { ReactNode } from 'react';
import styles from './index.module.sass';
import classNames from 'classnames';

export const InputSignWrap = ({ children, label, className, autogrow }: IArgs) => {
  return (
    <div
      className={classNames(
        styles.inputWithSign,
        className,
        autogrow && styles.autogrow,
      )}
    >
      {label && <span className={styles.inputLabel}>{label}</span>}
      {children}
    </div>
  );
};

interface IArgs {
  children: ReactNode;
  label: string | any;
  className?: any;
  autogrow?: boolean;
}
